import * as Yup from "yup";

const Validation = Yup.object({
  locale_code: Yup.string().required("Please select Language!"),
  // language_name: Yup.string().required("Please enter name for selected language!"),
});

export default Validation;
